import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';

const routes = [
  {
    path: '/',
    redirect: 'dashboard',
    component: DashboardLayout,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/Dashboard.vue')
      },
      {
        path: '/ingresos',
        name: 'ingresos',
        component: () => import('../views/Ingreso/Ingreso.vue'),
        meta: { keepAlive: true },
      },  
      {
        path: '/ingresos/documentos/:id',
        name: 'documentos',
        props: true,
        component: () => import('../views/Ingreso/Documentos.vue')
      },
      {
        path: '/ingresos/incompletos/:grupo',
        name: 'incompletos',
        component: () => import('../views/Ingreso/Incompleto.vue'),
        meta: { keepAlive: true }
      },
      {
        path: '/ingresos/pendientes/:grupo',
        name: 'pendientes',
        component: () => import('../views/Ingreso/Pendiente.vue'),
        meta: { keepAlive: true }
      },
      {
        path: '/ingresos/completados/:grupo',
        name: 'completados',
        component: () => import('../views/Ingreso/Completado.vue')
      },
      {
        path: '/ingresos/pagados/:grupo',
        name: 'pagados',
        component: () => import('../views/Ingreso/Pagado.vue')
      },
      {
        path: '/ingresos/pagados/:grupo/:estado',
        name: 'pagado-estado',
        component: () => import('../views/Ingreso/Pagado.vue'),
        meta: { keepAlive: true }
      },
      {
        path: '/ingresos/create',
        name: 'ingreso-crear',
        component: () => import('../views/Ingreso/Crear.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: '/ingresos/details/:id',
        name: 'detalle',
        component: () => import('../views/Ingreso/Detalle.vue')
      },
      {
        path: '/egresos',
        name: 'egresos',
        component: () => import('../views/Egreso/Egreso.vue')
      },  
      {
        path: '/egresos/documentos/:id',
        name: 'egreso-documentos',
        props: true,
        component: () => import('../views/Egreso/Documentos.vue')
      },
      {
        path: '/egresos/incompletos/:grupo',
        name: 'egreso-incompletos',
        component: () => import('../views/Egreso/Incompleto.vue')
      },
      {
        path: '/egresos/pendientes/:grupo',
        name: 'egreso-pendientes',
        component: () => import('../views/Egreso/Pendiente.vue')
      },
      {
        path: '/egresos/completados/:grupo',
        name: 'egreso-completados',
        component: () => import('../views/Egreso/Completado.vue')
      },
      {
        path: '/egresos/pagados/:grupo',
        name: 'egreso-pagados',
        component: () => import('../views/Egreso/Pagado.vue')
      },
      {
        path: '/egresos/pagados/:grupo/:estado',
        name: 'egreso-pagado-estado',
        component: () => import('../views/Egreso/Pagado.vue')
      },
      {
        path: '/egresos/create',
        name: 'egreso-crear',
        component: () => import('../views/Egreso/Crear.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: '/egresos/details/:id',
        name: 'egreso-detalle',
        component: () => import('../views/Egreso/Detalle.vue')
      },
      {
        path: '/empresas',
        name: 'empresas',
        component: () => import('../views/Empresa/Empresa.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: '/empresas/details/:id',
        name: 'empresa-detalle',
        component: () => import('../views/Empresa/Detalle.vue'),
        meta: { requiresAdmin: true }
      }, 
      {
        path: '/empresas/create',
        name: 'empresa-crear',
        component: () => import('../views/Empresa/Crear.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: '/usuarios',
        name: 'usuarios',
        component: () => import('../views/Usuario/Usuario.vue'),
        meta: { requiresAdmin: true }
      }, 
      {
        path: '/usuarios/details/:id',
        name: 'usuario-detalle',
        component: () => import('../views/Usuario/Detalle.vue'),
      },  
      {
        path: '/usuarios/create',
        name: 'usuario-crear',
        component: () => import('../views/Usuario/Crear.vue'),
        meta: { requiresAdmin: true }
      }, 
      {
        path: '/choferes',
        name: 'choferes',
        component: () => import('../views/Chofer/Chofer.vue'),
        meta: { requiresAdmin: true }
      },   
      {
        path: '/choferes/details/:id',
        name: 'chofer-detalle',
        component: () => import('../views/Chofer/Detalle.vue'),
        meta: { requiresAdmin: true }
      }, 
      {
        path: '/choferes/create',
        name: 'chofer-crear',
        component: () => import('../views/Chofer/Crear.vue'),
        meta: { requiresAdmin: true }
      }, 
      {
        path: '/choferes/create-modal',
        name: 'chofer-crear-modal',
        component: () => import('../views/Chofer/CrearModal.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: '/materiales',
        name: 'materiales',
        component: () => import('../views/Material/Material.vue'),
        meta: { requiresAdmin: true }
      }, 
      {
        path: '/materiales/create',
        name: 'material-crear',
        component: () => import('../views/Material/Crear.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: '/materiales/details/:id',
        name: 'material-detalle',
        component: () => import('../views/Material/Detalle.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: '/pagos',
        name: 'pagos',
        component: () => import('../views/Pago/Pago.vue'),
        meta: { requiresAdmin: true }
      },
       {
        path: '/pagos/create',
        name: 'nuevo pago',
        component: () => import('../views/Pago/Crear.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: '/pagos/details/:id',
        name: 'pago-detalle',
        component: () => import('../views/Pago/Detalle.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: '/plantas',
        name: 'plantas',
        component: () => import('../views/Planta/Planta.vue'),
        meta: { requiresAdmin: true }
      }, 
      {
        path: '/plantas/create',
        name: 'planta-crear',
        component: () => import('../views/Planta/Crear.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: '/plantas/details/:id',
        name: 'planta-detalle',
        component: () => import('../views/Planta/Detalle.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: '/folios',
        name: 'folios',
        component: () => import('../views/Folio/Folio.vue'),
        meta: { requiresAdmin: true }
      }, 
      {
        path: '/folios/create',
        name: 'folio-crear',
        component: () => import('../views/Folio/Crear.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: '/folios/details/:id',
        name: 'folio-detalle',
        component: () => import('../views/Folio/Detalle.vue'),
        meta: { requiresAdmin: true }
      }
    ]
  },
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('../views/Pages/Login.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('../views/Pages/Register.vue')
      },
      { path: '*', name: 'error',component: NotFound }
    ]
  }
];

export default routes;
